import { getExtensionValue } from "@medplum/core";
import { Patient } from "@medplum/fhirtypes";

import { Extensions } from "@/fhir/enums/extensions";

import { toast } from "./notifications";

export const patientHasUser = (patient: Patient): boolean => {
  return getExtensionValue(patient, Extensions.PatientHasUser) === true;
};

export function inactiveUserAccountNotification() {
  return toast({
    title: "Notification of chart update not sent to client",
    message: "Client doesn't have an active account.",
    type: "warning",
  });
}
